import React from "react";
import { portfolio } from "@/data/portfolio";
import useReveal from "@/hooks/useReveal";
import { useTheme } from "@/context/ThemeContext";

const Marquee = ({ items, slow = false }) => {
  const line = items.map((t, i) => (
    <span key={i} className="inline-flex items-center">
      <span className="font-serif text-2xl md:text-4xl leading-none px-5">{t}</span>
      <span className="opacity-50">·</span>
    </span>
  ));
  return (
    <div className="overflow-hidden hairline-b hairline" data-testid="disciplines-marquee">
      <div className="py-5">
        <div className={`marquee-track ${slow ? "marquee-slow" : ""}`}>
          {line}
          {line}
        </div>
      </div>
    </div>
  );
};

const Background = () => {
  const { theme } = useTheme();
  const ref1 = useReveal();
  const ref2 = useReveal();
  const { background } = portfolio;
  const frameImg = theme === "day" ? "/video_frames/frame_040.webp" : "/video_night_frames/frame_040.webp";

  return (
    <section id="background" data-testid="background-section" className="px-0">
      <div ref={ref1} className="reveal-up mx-auto max-w-[1400px] px-5 md:px-10 pt-16 md:pt-24">
        <div className="flex items-baseline justify-between mb-10">
          <div className="section-tag">
            <span style={{ color: "var(--ink)" }}>{background.section}</span>
            <span className="ml-3">{background.eyebrow}</span>
          </div>
          <div className="section-tag hidden md:block">→ Disciplines</div>
        </div>

        <h2 className="display text-4xl sm:text-5xl md:text-7xl lg:text-8xl max-w-[18ch]">
          {background.heading.split("who thinks").map((part, i, arr) =>
            i === 0 ? (
              <React.Fragment key={i}>
                {part}
                {arr.length > 1 && (
                  <>
                    <span className="display-italic" style={{ color: "var(--accent)" }}>who thinks</span>
                    {arr[1]}
                  </>
                )}
              </React.Fragment>
            ) : null
          )}
        </h2>
      </div>

      <div className="mt-12 md:mt-16">
        <Marquee items={portfolio.disciplines} />
      </div>

      <div ref={ref2} className="reveal-up mx-auto max-w-[1400px] px-5 md:px-10 mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-3 space-y-6">
          <div className="font-mono text-[0.72rem] uppercase tracking-microcap" style={{ color: "var(--ink-muted)" }}>
            /{portfolio.meta.name} · {portfolio.meta.title}
          </div>
          <div className="overflow-hidden rounded border" style={{ borderColor: "var(--rule)" }}>
            <img
              src={frameImg}
              alt="Editorial theme portrait"
              className="w-full aspect-[4/5] object-cover editorial-img transition-all duration-700 hover:scale-105"
            />
          </div>
        </div>
        <div className="md:col-span-9 space-y-6">
          {background.paragraphs.map((p, i) => (
            <p key={i} className={`font-serif text-lg md:text-xl leading-relaxed max-w-[68ch] ${i === 0 ? "dropcap" : ""}`}>
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Background;
